import { render, staticRenderFns } from "./swiperPreview.vue?vue&type=template&id=60b048a3&scoped=true"
import script from "./swiperPreview.vue?vue&type=script&lang=js"
export * from "./swiperPreview.vue?vue&type=script&lang=js"
import style0 from "./swiperPreview.vue?vue&type=style&index=0&id=60b048a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b048a3",
  null
  
)

export default component.exports